import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinkStyles = styled.span`
  a {
    color: ${(p) => p.theme.colors.brand};
    text-decoration: none;
  }
`;

export const LinkStylesUnderline = styled.span`
  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const LinkStylesNoColor = styled.span`
  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const LinkPAStyle = styled.a`
  color: ${(p) => p.theme.colors.brand};
  text-decoration: none;
`;

export const LinkPAStyleUnderline = styled.a`
  color: ${(p) => p.theme.colors.brand};
  text-decoration: underline;
`;

export const LinkUnderline = styled.a`
  color: inherit;
  text-decoration: underline;

  :hover {
    cursor: pointer;
  }
`;

export const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

export const StyledLinkUnderline = styled(Link)`
  color: inherit;
  text-decoration: underline;
`;

export const PAStyledLinkNoUnderline = styled(Link)`
  color: ${(p) => p.theme.colors.brand};
  text-decoration: none;
`;
